import React from 'react';
import PropTypes from 'prop-types';
import { nanoid } from 'nanoid';
import Dropzone from 'react-dropzone';
import classNames from 'classnames';
import { isIterableArray } from 'helpers/utils';
import Flex from './Flex';
import docImgUpload from 'assets/img/icons/docs.png';
import SimpleBarReact from 'simplebar-react';
import { Accordion, Button, Card, Form, Image, useAccordionButton } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import FalconLightBox from './FalconLightBox';

const getSize = size => {
 if (size < 1024) {
  return (
   <>
    <strong>{size}</strong> Byte
   </>
  );
 } else if (size < 1024 * 1024) {
  return (
   <>
    <strong>{(size / 1024).toFixed(2)}</strong> KB
   </>
  );
 } else {
  return (
   <>
    <strong>{(size / (1024 * 1024)).toFixed(2)}</strong> MB
   </>
  );
 }
};

const CustomToggle = ({ children, eventKey, id, base64, path, size }) => {
 const decoratedOnClick = useAccordionButton(eventKey);
 return (
  <Flex alignItems="center" key={id + path} className="cursor-pointer">
   <Image rounded width={30} height={30} src={base64} alt={path} onClick={decoratedOnClick} />
   <Flex justifyContent="between" alignItems="center" className="ms-3 flex-1" onClick={decoratedOnClick}>
    <div>
     <h6 className="text-truncate m-0" style={{ maxWidth: '15vw' }}>
      {path}
     </h6>
     <Flex className="position-relative" align="center">
      <p className="mb-0 fs--1 text-400 line-height-1">
       <strong>{getSize(size)}</strong>
      </p>
     </Flex>
    </div>
   </Flex>
   {children}
  </Flex>
 );
};

const CustomToggle2 = ({ children, eventKey, img }) => {
 const decoratedOnClick = useAccordionButton(eventKey);
 return (
  <Flex alignItems="center" key={eventKey} className="cursor-pointer">
   <Image rounded width={30} height={30} src={img} onClick={decoratedOnClick} />
   <Flex justifyContent="between" alignItems="center" className="ms-3 flex-1" onClick={decoratedOnClick}>
    <div>
     <h6 className="text-truncate m-0" style={{ maxWidth: '15vw' }}>
      {img}
     </h6>
     <Flex className="position-relative" align="center">
      <p className="mb-0 fs--1 text-400 line-height-1">
       <strong>imagen</strong>
      </p>
     </Flex>
    </div>
   </Flex>
   {children}
  </Flex>
 );
};

const UploadFiles = ({
 dropzoneArea,
 placeholder,
 classInput,
 className,
 onChange,
 files,
 preview,
 buffer,
 style,
 isLoading,
 noFiles,
 ...rest
}) => {
 return (
  <>
   <Dropzone
    onDrop={acceptedFiles => {
     const stringFiles = [];
     if (acceptedFiles.length && !noFiles) {
      acceptedFiles.map(file => {
       const reader = new FileReader();
       reader[buffer ? 'readAsArrayBuffer' : 'readAsDataURL'](file);
       reader.onabort = () => console.log('file reading was aborted');
       reader.onerror = () => console.log('file reading has failed');
       //reader.onprogress = () => console.log('file onprogress');
       reader.onloadstart = () => isLoading(true);
       reader.onloadend = () => isLoading(false);
       reader.onload = () => {
        stringFiles.push({
         id: nanoid(),
         [buffer ? 'buffer' : 'base64']: reader.result,
         size: file.size,
         path: file.path,
         type: file.type
        });
        onChange([...stringFiles]);
       };
       return true;
      });
     } else if (acceptedFiles.length && noFiles) {
      onChange(acceptedFiles.map(file => Object.assign(file, { preview: URL.createObjectURL(file) })));
     }
    }}
   >
    {({ getRootProps, getInputProps }) => (
     <>
      <div
       {...getRootProps({
        className: classNames({ 'dropzone-area': dropzoneArea }, className)
       })}
      >
       <Form.Control className={classInput} {...getInputProps({ ...rest })} />
       {placeholder}
      </div>
     </>
    )}
   </Dropzone>
   {preview && isIterableArray(files) ? (
    <div className="border-top mt-3">
     <SimpleBarReact style={style}>
      {rest.accept !== 'image/*' ? (
       typeof files[0] === 'string' ? (
        files.map((e, i) => (
         <Card className="mb-2" key={i}>
          <Card.Header className="py-2">
           <Flex alignItems="center">
            <Image rounded width={30} height={30} src={docImgUpload} alt={e} />
            <Flex justifyContent="between" alignItems="center" className="ms-3 flex-1">
             <div>
              <Link to={e} target="_blank" className="d-block link-dark">
               <h6 className="text-truncate m-0" style={{ maxWidth: '15vw' }}>
                {e}
               </h6>
              </Link>
              <Flex className="position-relative" align="center">
               <p className="mb-0 fs--1 text-400 line-height-1">
                <strong>url del documento</strong>
               </p>
              </Flex>
             </div>
            </Flex>
            <Button
             variant="falcon-primary"
             type="button"
             className="p-0 icon-item icon-item-sm"
             disabled={rest?.disabled}
             onClick={() => onChange(files.filter((_, indx) => indx !== i))}
            >
             <FontAwesomeIcon icon="trash" />
            </Button>
           </Flex>
          </Card.Header>
         </Card>
        ))
       ) : (
        files.map(({ id, path, size }) => (
         <Card className="mb-2" key={id + path}>
          <Card.Header className="py-2">
           <Flex alignItems="center">
            <Image rounded width={30} height={30} src={docImgUpload} alt={path} />
            <Flex justifyContent="between" alignItems="center" className="ms-3 flex-1">
             <div>
              <h6 className="text-truncate m-0" style={{ maxWidth: '15vw' }}>
               {path}
              </h6>
              <Flex className="position-relative" align="center">
               <p className="mb-0 fs--1 text-400 line-height-1">
                <strong>{getSize(size)}</strong>
               </p>
              </Flex>
             </div>
            </Flex>
            <Button
             variant="falcon-primary"
             type="button"
             className="p-0 icon-item icon-item-sm"
             //disabled={rest?.disabled}
             onClick={() => onChange(files.filter(file => file.id !== id))}
            >
             <FontAwesomeIcon icon="trash" />
            </Button>
           </Flex>
          </Card.Header>
         </Card>
        ))
       )
      ) : (
       <Accordion defaultActiveKey="0">
        {typeof files[0] === 'string'
         ? files.map((e, i) => (
            <Card className="mb-2" key={i}>
             <Card.Header className="py-2">
              <CustomToggle2 eventKey={i} img={e}>
               <Button
                variant="falcon-primary"
                type="button"
                className="p-0 icon-item icon-item-sm"
                disabled={rest?.disabled}
                onClick={() => onChange(files.filter((f, ind) => ind !== i))}
               >
                <FontAwesomeIcon icon="trash" />
               </Button>
              </CustomToggle2>
             </Card.Header>
             <Accordion.Collapse eventKey={i}>
              <Card.Body>
               <FalconLightBox image={e}>
                <Image src={e} fluid />
               </FalconLightBox>
              </Card.Body>
             </Accordion.Collapse>
            </Card>
           ))
         : files.map(({ id, path, base64, size }, i) => (
            <Card className="mb-2" key={i}>
             <Card.Header className="py-2">
              <CustomToggle eventKey={i} id={id} base64={base64} path={path} size={size}>
               <Button
                variant="falcon-primary"
                type="button"
                className="p-0 icon-item icon-item-sm"
                //disabled={rest?.disabled}
                onClick={() => onChange(files.filter(file => file.id !== id))}
               >
                <FontAwesomeIcon icon="trash" />
               </Button>
              </CustomToggle>
             </Card.Header>
             <Accordion.Collapse eventKey={i}>
              <Card.Body>
               <FalconLightBox image={base64}>
                <Image alt={path} src={base64} fluid />
               </FalconLightBox>
              </Card.Body>
             </Accordion.Collapse>
            </Card>
           ))}
       </Accordion>
      )}
     </SimpleBarReact>
    </div>
   ) : preview && typeof files === 'string' ? (
    <div className="border-top mt-3">
     {rest.accept !== 'image/*' ? (
      <Card className="mb-2">
       <Card.Header className="py-2">
        <Flex alignItems="center">
         <Image rounded width={30} height={30} src={docImgUpload} alt={files} />
         <Flex justifyContent="between" alignItems="center" className="ms-3 flex-1">
          <div>
           <Link to={files} target="_blank" className="d-block link-dark">
            <h6 className="text-truncate m-0" style={{ maxWidth: '15vw' }}>
             {files}
            </h6>
           </Link>
           <Flex className="position-relative" align="center">
            <p className="mb-0 fs--1 text-400 line-height-1">
             <strong>url del documento</strong>
            </p>
           </Flex>
          </div>
         </Flex>
         <Button
          variant="falcon-primary"
          type="button"
          className="p-0 icon-item icon-item-sm"
          disabled={rest?.disabled}
          onClick={() => onChange(null)}
         >
          <FontAwesomeIcon icon="trash" />
         </Button>
        </Flex>
       </Card.Header>
      </Card>
     ) : (
      <Accordion defaultActiveKey="0">
       <Card className="mb-2">
        <Card.Header className="py-2">
         <CustomToggle2 eventKey={0} img={files}>
          <Button
           variant="falcon-primary"
           type="button"
           className="p-0 icon-item icon-item-sm"
           disabled={rest?.disabled}
           onClick={() => onChange(null)}
          >
           <FontAwesomeIcon icon="trash" />
          </Button>
         </CustomToggle2>
        </Card.Header>
        <Accordion.Collapse eventKey={0}>
         <Card.Body>
          <FalconLightBox image={files}>
           <Image src={files} fluid />
          </FalconLightBox>
         </Card.Body>
        </Accordion.Collapse>
       </Card>
      </Accordion>
     )}
    </div>
   ) : (
    <></>
   )}
  </>
 );
};

getSize.propTypes = { size: PropTypes.number.isRequired };

CustomToggle.propTypes = {
 children: PropTypes.node,
 eventKey: PropTypes.number,
 id: PropTypes.string,
 base64: PropTypes.string,
 path: PropTypes.string,
 size: PropTypes.number
};

CustomToggle2.propTypes = { children: PropTypes.node, eventKey: PropTypes.number, img: PropTypes.string };

UploadFiles.propTypes = {
 onChange: PropTypes.func.isRequired,
 isLoading: PropTypes.func,
 placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
 classInput: PropTypes.string,
 className: PropTypes.string,
 files: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
 preview: PropTypes.bool,
 isMulti: PropTypes.bool,
 dropzoneArea: PropTypes.bool,
 multiple: PropTypes.bool,
 buffer: PropTypes.bool,
 noFiles: PropTypes.bool,
 style: PropTypes.object
};

UploadFiles.defaultProps = {
 placeholder: '',
 files: [],
 preview: false,
 dropzoneArea: true,
 multiple: false,
 buffer: false,
 noFiles: false,
 isLoading: e => console.log('cargando... ', e)
};

export default UploadFiles;
